module.exports = __webpack_public_path__ + "assets/img/0411.42aa860f.png";